module.exports = __webpack_public_path__ + "img/greyCodeSnip.9d1593c8.svg";